const irrf = [
    { limit: 2428.8, rate: 0 }, { limit: 2826.65, rate: .075, deduction: 182.16 },
    { limit: 3751.05, rate: .15, deduction: 394.16 }, { limit: 4664.68, rate: .225, deduction: 675.49 },
    { limit: Infinity, rate: .275, deduction: 908.73 },
];
const plr = [
    { limit: 8214.4, rate: 0 }, { limit: 9922.28, rate: .075, deduction: 616.08 },
    { limit: 13167, rate: .15, deduction: 1360.25 }, { limit: 16380.38, rate: .225, deduction: 2347.78 },
    { limit: Infinity, rate: .275, deduction: 3166.8 },
];
export const RULES = {
    2025: {
        inss: [{ limit: 1518, rate: .075 }, { limit: 2793.88, rate: .09 }, { limit: 4190.83, rate: .12 }, { limit: 8157.41, rate: .14 }],
        irrf, dependentDeduction: 189.59, simplifiedDeduction: 607.2, fgtsRate: .08, plr,
    },
    2026: {
        inss: [{ limit: 1621, rate: .075 }, { limit: 2902.84, rate: .09 }, { limit: 4354.27, rate: .12 }, { limit: 8475.55, rate: .14 }],
        irrf, dependentDeduction: 189.59, simplifiedDeduction: 607.2, fgtsRate: .08, plr,
        irrfReduction: (income, tax) => income <= 5000 ? tax : income < 7350 ? Math.min(tax, Math.max(0, 978.62 - .133145 * income)) : 0,
    },
};
export const sources = {
    inss: 'https://www.gov.br/inss/pt-br/direitos-e-deveres/inscricao-e-contribuicao/tabela-de-contribuicao-mensal',
    irrf: 'https://www.gov.br/receitafederal/pt-br/assuntos/meu-imposto-de-renda/tabelas/2026',
    fgts: 'https://www.fgts.gov.br/Paginas/subpaginas/recolhimento-empregado.aspx',
};
//# sourceMappingURL=rules.js.map